import { GraduationCap } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const SiteFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-12 px-6 md:px-12 lg:px-24 bg-[#0A0B10] text-white">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-2">
          <GraduationCap className="w-6 h-6 text-[#002FA7]" />
          <span className="font-display">Gabriel Consultant</span>
        </div>
        <p className="text-slate-400 text-sm">{t("landing.footer")}</p>
      </div>
    </footer>
  );
};
